// University of Virginia's bachelor's majors (#2740). Read on 2026-10-01
// from UVA's official Undergraduate Record 2026-2027 (records.ureg.virginia.edu,
// the University Registrar's catalog), Programs and Degrees Offered: every
// bachelor's degree program in each school's table, with the degree as the
// Record abbreviates it. Where the Record lists majors under one degree (Art,
// B.A.: Art History and Studio Art; Area Studies, B.A.: Latin American
// Studies; Interdisciplinary, B.A.: each "Interdisciplinary - <name>" major),
// each major is listed. Concentrations, tracks, minors, certificates and
// graduate degrees are left out, and so is the Bachelor of Professional
// Studies in Health Sciences Management, which the Record marks as a
// teach-out (last admit term Spring 2026). The Bachelor of Interdisciplinary
// Studies is the School of Continuing and Professional Studies' degree.
const majors = {
    "slug": "university-of-virginia",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in UVA's official Undergraduate Record 2026-2027, by school. Concentrations, minors, certificates and graduate degrees are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UVA Undergraduate Record 2026-2027, Programs and Degrees Offered",
                "url": "https://records.ureg.virginia.edu/content.php?catoid=72&navoid=6697"
            },
            "majors": [
                {
                    "name": "African-American and African Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Statistics",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies (Area Studies)",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.S."
                },
                {
                    "name": "Behavioral Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Drama",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Foreign Affairs",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "Government",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Chinese Language & Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Cognitive Science",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - East Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Echols Scholars Program",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Environmental Thought & Practice",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - German Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Human Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Japanese Language & Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Jewish Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Medieval Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Middle Eastern Languages and Literatures",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Middle Eastern Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Political & Social Thought",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Political Philosophy, Policy, & Law",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - South Asian Languages and Literatures",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - South Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary - Women, Gender, and Sexuality",
                    "degree": "B.A."
                },
                {
                    "name": "Italian",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Slavic Languages and Literatures",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Architecture",
            "source": {
                "label": "UVA Undergraduate Record 2026-2027, Programs and Degrees Offered",
                "url": "https://records.ureg.virginia.edu/content.php?catoid=72&navoid=6697"
            },
            "majors": [
                {
                    "name": "Architectural History",
                    "degree": "B.Ar.H."
                },
                {
                    "name": "Architecture",
                    "degree": "B.S."
                },
                {
                    "name": "Urban and Environmental Planning",
                    "degree": "B.U.E.P."
                }
            ]
        },
        {
            "name": "McIntire School of Commerce",
            "source": {
                "label": "UVA Undergraduate Record 2026-2027, Programs and Degrees Offered",
                "url": "https://records.ureg.virginia.edu/content.php?catoid=72&navoid=6697"
            },
            "majors": [
                {
                    "name": "Commerce",
                    "degree": "B.S.C."
                }
            ]
        },
        {
            "name": "School of Data Science",
            "source": {
                "label": "UVA Undergraduate Record 2026-2027, Programs and Degrees Offered",
                "url": "https://records.ureg.virginia.edu/content.php?catoid=72&navoid=6697"
            },
            "majors": [
                {
                    "name": "Data Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Education and Human Development",
            "source": {
                "label": "UVA Undergraduate Record 2026-2027, Programs and Degrees Offered",
                "url": "https://records.ureg.virginia.edu/content.php?catoid=72&navoid=6697"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "English as a Second Language Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Kinesiology",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Speech Communication Disorders",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Youth and Social Innovation",
                    "degree": "B.S.Ed."
                }
            ]
        },
        {
            "name": "School of Engineering and Applied Science",
            "source": {
                "label": "UVA Undergraduate Record 2026-2027, Programs and Degrees Offered",
                "url": "https://records.ureg.virginia.edu/content.php?catoid=72&navoid=6697"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Science",
                    "degree": "B.S."
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Systems Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Frank Batten School of Leadership and Public Policy",
            "source": {
                "label": "UVA Undergraduate Record 2026-2027, Programs and Degrees Offered",
                "url": "https://records.ureg.virginia.edu/content.php?catoid=72&navoid=6697"
            },
            "majors": [
                {
                    "name": "Public Policy and Leadership",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "UVA Undergraduate Record 2026-2027, Programs and Degrees Offered",
                "url": "https://records.ureg.virginia.edu/content.php?catoid=72&navoid=6697"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                }
            ]
        },
        {
            "name": "School of Continuing and Professional Studies",
            "source": {
                "label": "UVA Undergraduate Record 2026-2027, Programs and Degrees Offered",
                "url": "https://records.ureg.virginia.edu/content.php?catoid=72&navoid=6697"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.I.S."
                }
            ]
        }
    ]
};

export default majors;
